module.exports = __webpack_public_path__ + "img/document.9fa5e3ba.svg";